<template>
    <v-card flat v-if="basketItem && basketProduct && product">
        <v-card-title class="primary-transparent-5 title">
            <span>{{ title }}</span>

            <v-spacer/>

            <v-icon>info</v-icon>
        </v-card-title>

        <related-products-thumbnail
            class="px-2 py-3"
            :product="localProduct"
            :initial-quantity="missingQuantity"
            hide-amount-input
            basket-button-text="Additional interesting"
        />
    </v-card>
</template>

<script>
import BasketButton from '@breakmedia/prime-vue-product/src/product-page/BasketButton';
import ProductThumbnailSmall from '@breakmedia/prime-vue-product/src/ProductThumbnailSmall';
import {getProducts} from '@breakmedia/prime-vue-product/src/store/getProducts';
import {Observable} from 'rxjs';

const name = 'CheaperBulkPrice';

export default {
    name: name,
    props: {
        basketItem: Object,
        basketProduct: Object,
        missingQuantity: Number,
    },
    components: {
        ProductThumbnailSmall,
        BasketButton,
    },
    data() {
        return {
            product: null,
            productsSubscriber: null,
        };
    },
    created() {
        this.productsSubscriber = getProducts(new Observable(
            subscriber => this.$watch('basketItem', basketItem => {
                const priceParams = this.$basket.getPriceParams([basketItem], this.deliveryCountry);
                priceParams[0].quantity[basketItem.catalog_item_id] += this.missingQuantity;
                subscriber.next({
                    ids: [basketItem.catalog_item_id],
                    priceParams: priceParams,
                });
            }, {immediate: true})
        )).subscribe(products => {
            this.product = products[0];
        });
    },
    beforeDestroy() {
        this.productsSubscriber.unsubscribe();
    },
    computed: {
        title() {
            return this.$language.translate('Order %value% more cheaper!').replace('%value%', this.missingQuantity);
        },
        deliveryCountry() {
            return this.$order.getDeliveryCountry();
        },
        localProduct() {
            return {
                ...this.product,
                price: {
                    original_price_inkl_vat: this.$basket.getPriceData(this.basketItem, this.basketProduct).original_price_inkl_vat,
                    price: this.$basket.getPriceData(this.basketItem, this.product).price,
                },
            };
        },
    },
};
</script>